import $ from 'jquery-lite'
import {CsCanvas} from "@/lib/gooroomee/canvas/ycs/js/CsCanvas-1.0.0";
import _ from "lodash";

const RoomDocCanvas = function(data = {}){
    this.data = {
        canvasToolLineWidth: {
            pencil: 10,
            highlighter: 17,
            eraser: 17,
            text: 17
        },
        canvasToolLineWidthRatio: 1
    };
    Object.assign(this.data, data);
}

Object.assign(RoomDocCanvas.prototype, {
    getContainer: function(){
        return this.data.$el?.parentElement
            || this.data.$vue?.$el.parentElement;
    },
    getDocument: function(){
        return this.data.$el?.ownerDocument
            || this.data.$vue?.$el.ownerDocument;
    },
    getApi: function(){
        return this.data.$roomApi
            || this.data.$vue?.$roomApi;
    },
    getRoomDoc: function(){
        return this.data.roomDoc
            || this.data.$vue.roomDoc;
    },
    sendDraw: function(data){
        if(!data.docId){
            let {roomGroupId, docId, docPageId} = this.getRoomDoc();
            Object.assign(data, {roomGroupId, docId, docPageId});
        }
        this.getApi().Doc.sendDraw(data);
    },
    getMe: function(){
        return this.data.$me
            || this.data.$vue?.$me;
    },
    setPointerEvents: function(v){
        this.getContainer().setAttribute('data-pointer-events-none', ''+v);
        this.getDocument().body.setAttribute('data-pointer-events-none', ''+v);
    },
    getCanvasToolLineWidth: function(toolType, lineWidth){
        toolType = toolType.toLowerCase();

        if(lineWidth !== undefined){
            this.data.canvasToolLineWidth[toolType] = lineWidth;
        }

        let ratio = 1;
        switch (toolType) {
            case 'highlighter':
                ratio = 2;
                break;
            case 'eraser':
                ratio = 4;
                break;
            case 'text': {
                let fs = parseFloat((this.data.canvasToolLineWidthRatio)*1);
                fs *= this.data.canvasToolLineWidth[toolType] / 5;
                return fs+'em sans-serif';
            }
        }

        let w = Math.ceil(this.data.canvasToolLineWidth[toolType] * this.canvasToolLineWidthRatio * ratio);
        if(toolType === 'eraser'){
            w = Math.max(w, 10);
        }

        return w;
    },
    isRealTimeMode: function(){
        // // TODO
        // if(this.data.realTimeMode === undefined){
        //     this.data.realTimeMode = ['gooroomee'].indexOf(this.data.groupId) > -1;
        // }
        return this.data.realTimeMode;
    },
    init: function(view){
        const THIS = this;

        view = $(view || this.data.$el);
        THIS.csCanvas = new CsCanvas(view, {
            smoothValue: 0,
            laserPointerTruncate: 0,
            css: {
                // background: ''
                backgroundColor: '#fff'
            },
            toolkit: 'Pencil',
            minZoom: 0.75,
            maxZoom: 4,
            metrix: {
                // holdRatio: true
            }
        });

        THIS.setStrokeStyle(true);
        THIS.csCanvas.setToolkit('Pencil');

        let csc = THIS.csCanvas;
        // csc.changeJQEventHandle();
        csc.on('changesize', function(){
            THIS.setStrokeStyle();
        });

        let jobList = [];
        let executeJob;
        let addJob = (job) => {
            jobList.push(job);

            if(!executeJob){
                executeJob = true;
                setTimeout(function(){
                    // requestAnimationFrame(function(){
                    let job;
                    do{
                        try{
                            job = jobList.shift();
                            if(job){
                                job();
                            }
                        }catch(e){
                            console.error(e);
                        }
                    }while(job);
                    executeJob = false;
                });
            }
        }

        let roomGroupId, docId, docPageId;

        // csc.on('changetoolkit', (event) => {
        // });

        let sIdx = 0;
        let sCount = 4 * 5;
        csc.on('drawstart', (event) => {
            csc.getBase().focus();
            this.setPointerEvents(true);

            const roomDoc = THIS.getRoomDoc();
            roomGroupId = roomDoc.roomGroupId;
            docId = roomDoc.docId;
            docPageId = roomDoc.docPageId;

            addJob(() => {
                if(event.toolkit.type==='LaserPointer'){
                    this.sendDraw({
                        roomGroupId, docId, docPageId,
                        data: {
                            toolkit: event.toolkit.type,
                            drawType: 'drawstart',
                            data: {
                                point: event.drawData.oriPoint,
                                strokeStyle: event.toolkit.style.strokeStyle
                            }
                        }
                    });
                }else{
                    if(THIS.isRealTimeMode()){
                        sIdx = 0;
                        this.sendDraw({
                            roomGroupId, docId, docPageId,
                            data: {
                                toolkit: event.toolkit.type,
                                drawType: 'drawstart',
                                data: {
                                    point: event.drawData.oriPoint,
                                    style: event.toolkit.style
                                }
                            }
                        });
                    }
                }
            });
        }).on('drawing', (event) => {
            if(event.toolkit.type==='LaserPointer'){
                THIS.__draw_rz_count = THIS.__draw_rz_count || 0;
                if(++THIS.__draw_rz_count < 4){
                    return;
                }
                THIS.__draw_rz_count = 0;

                clearTimeout(THIS.__draw_rz_timer);
                THIS.__draw_rz_timer = setTimeout(() => {
                    this.sendDraw({
                        roomGroupId,
                        data: {
                            drawType: 'drawing',
                            data: {
                                point: event.drawData.oriPoint,
                            }
                        }
                    });
                    THIS.__draw_rz_timer = null;
                }, 1);
                return;
            }

            if(THIS.isRealTimeMode()){
                let list = event.drawData.oriPointList;
                if(list && (list.length-2) % sCount == 0){
                    list = list.slice(sIdx, sIdx+sCount);
                    sIdx += list.length;
                    this.sendDraw({
                        roomGroupId, docId, docPageId,
                        data: {
                            toolkit: event.toolkit.type,
                            drawType: 'drawing',
                            point: list
                        }
                    });
                }
            }
        }).on('drawend', (event) => {
            this.setPointerEvents(false);

            addJob(() => {
                switch (event.toolkit.type) {
                    case 'LaserPointer':
                        this.sendDraw({
                            roomGroupId, docId, docPageId,
                            data: {
                                drawType: event.type,
                                toolkit: event.toolkit.type
                            }
                        });
                        break;
                    // drawstart 이벤트가 일어나지 않아 마지막으로 drawstart 시 가져온 roomGroupId, docId, docPageId 를 사용하는 이슈가 있음.
                    // case 'Line':
                    // case 'Triangle':
                    // case 'Rectangle':
                    // case 'Circle':
                    //     this.sendDraw({
                    //         roomGroupId, docId, docPageId,
                    //         data: {
                    //             toolkit: event.toolkit.type,
                    //             drawType: event.type,
                    //             data: {
                    //                 point: event.drawData.oriPointList,
                    //                 style: event.toolkit.style
                    //             }
                    //         }
                    //     });
                    //     break;
                    default:
                        this.sendDraw({
                            data: {
                                toolkit: event.toolkit.type,
                                drawType: event.type,
                                data: {
                                    style: event.toolkit.style,
                                    point: event.drawData.oriPointList
                                }
                            }
                        });
                        break;
                }
            });

            if(!event.toolkit || !event.toolkit.type || event.toolkit.type === 'LaserPointer'){
                return;
            }
            // RoomUI.Doc.drawDocumentStream();
        }).on('drawtext', (event) => {
            addJob(() => {
                this.sendDraw({
                    // roomGroupId, docId, docPageId,
                    data: {
                        toolkit: event.toolkit.type,
                        drawType: event.type,
                        data: {
                            point: event.drawData.oriPoint,
                            text: event.drawData.text,
                            style: event.toolkit.style
                        }
                    }
                });
            });

            // RoomUI.Doc.drawDocumentStream();
        }).on('zoom move', (event) => {
            this.setPointerEvents(false);
        }).on('clear', () => {
            this.setPointerEvents(false);

            addJob(() => {
                this.sendDraw({
                    // roomGroupId, docId, docPageId,
                    data: {
                        toolkit: 'Eraser',
                        drawType: 'clear'
                    }
                });
            });

            // RoomUI.Doc.drawDocumentStream();
        });
    },
    setStrokeStyle: function(initColor){
        let THIS = this;

        let csCanvas = THIS.csCanvas
            ,metrix = csCanvas.metrix
            ,baseValue = 1200 * 900
            ,ratio = (metrix.oriWidth * metrix.oriHeight) / baseValue
        ;
        THIS.data.canvasToolLineWidthRatio = ratio;

        let toolkits = csCanvas.toolkits;

        const currentToolkit = _.cloneDeep(THIS.csCanvas.getCurrentToolkit());

        // lazor pointer
        // toolkits.LaserPointer.cursor = 'url("images/room/doc/cursor_razor_red.png"), default';
        // pencil
        // toolkits.Pencil.style.lineWidth = 6;// THIS.getCanvasToolLineWidth('pencil');
        // toolkits.Pencil.cursor = 'url("images/room/doc/cursor_pencil_yellow.png"), default';
        if(initColor){
            toolkits.Pencil.style.strokeStyle = '#0060FF';
        }

        // highlighter
        // toolkits.Highlighter.style.lineWidth = 17; // THIS.getCanvasToolLineWidth('highlighter');
        // toolkits.Highlighter.style.opacity = 0.4;
        // toolkits.Highlighter.cursor = 'url("images/room/doc/cursor_highlighter_yellow.png"), default';
        if(initColor){
            toolkits.Highlighter.style.strokeStyle = '#FFF200';
        }

        // text
        if(toolkits.Text){
            // toolkits.Text.style.font = parseInt((ratio+1)*14)+'px
            // sans-serif';
            // toolkits.Text.style.font = parseFloat((ratio)*1.4+1)+'em
            // sans-serif';
            // toolkits.Text.style.font = THIS.getCanvasToolLineWidth('text', 10);
        }

        // eraser
        // toolkits.Eraser.style.lineWidth = 20;// THIS.getCanvasToolLineWidth('eraser');
        // toolkits.Eraser.cursor = 'url("images/room/doc/cursor_eraser_blue.png"), default';
        // move
        // toolkits.Move.cursor = 'url("images/room/doc/cursor_hand.png"), default';

        if (currentToolkit) {
            switch (currentToolkit.type) {
                case 'Pencil':
                    toolkits.Pencil.style.lineWidth = currentToolkit.style.lineWidth;
                    toolkits.Pencil.cursor = 'default';
                    toolkits.Pencil.style.strokeStyle = currentToolkit.style.strokeStyle;
                    break;
                case 'Highlighter':
                    toolkits.Highlighter.style.lineWidth = currentToolkit.style.lineWidth;
                    toolkits.Highlighter.style.opacity = currentToolkit.style.opacity;
                    toolkits.Highlighter.cursor = 'default';
                    toolkits.Highlighter.style.strokeStyle = currentToolkit.style.strokeStyle;
                    break;
                case 'Eraser':
                    toolkits.Eraser.style.lineWidth = currentToolkit.style.lineWidth;
                    toolkits.Eraser.cursor = `url(${require('@/assets/roomType/lms/img/cursor_eraser_blue.png')}), default`;
                    break;
                case 'Text':
                    toolkits.Text.cursor = 'text';
                    toolkits.Text.style.font = THIS.getCanvasToolLineWidth('text', this.textSize || 10);
                    break;
                case 'LaserPointer':
                case 'Move':
                    toolkits[currentToolkit.type].cursor = 'default';
                    break;
            }
        }

    },
    onDrawData: function({userId, draw}){
        let {docId, docPageId} = draw;
        let drawData = draw.data;

        if(draw.data.toolkit){
            const roomDoc = this.getRoomDoc();
            if(roomDoc.docId != docId || roomDoc.docPageId != docPageId){
                return;
            }
        }

        let c = this.csCanvas;
        let t = c.toolkits[draw.data.toolkit || 'LaserPointer'];

        switch (drawData.drawType) {
            case 'drawstart': {
                if(!t) return;
                if(drawData.toolkit==='LaserPointer'){
                    this.data.laserPointer = {
                        docId: docId,
                        docPageId: docPageId
                    };
                    drawData.data.id = userId;
                    // if(!Room.isLiveMode()){
                    drawData.data.name = this.getApi().User.getNickname(userId);
                    // }
                    t.draw(drawData.data);
                    return;
                }else{
                    t.draw(drawData.data.point, drawData.data.style, userId, 1);
                    return;
                }
            }
            case 'LaserPointer':
                break;
            case 'drawing': {
                if (!t) return;
                if (!drawData.toolkit || drawData.toolkit === 'LaserPointer') {
                    if (!this.data.laserPointer) {
                        return;
                    }

                    drawData.data.id = userId;
                    if (userId) {
                        clearTimeout(this.data['_draw_timer_' + userId]);
                        this.data['_draw_timer_' + userId] = setTimeout(function () {
                            t.draw(drawData.data);
                        }, 1);
                        // t.draw(drawData.data);
                    } else {
                        t.draw(drawData.data);
                    }
                    return;
                } else {
                    if(drawData.data) // TODO 원인 파악 필요
                        t.draw(drawData.data.point, null, userId, 2);
                    return;
                }
            }
            case 'drawend':
                if(!t) return;
                switch (drawData.toolkit) {
                    case 'LaserPointer':
                        delete this.data.laserPointer;
                        clearTimeout(this.data['_draw_timer_'+userId]);
                        t.draw(userId, true);
                        return;
                    case 'Line':
                    case 'TwoLines':
                    case 'Rectangle':
                    case 'Diamond':
                    case 'Pentagon':
                    case 'Star':
                    case 'Circle':
                    case 'Triangle':
                        t.draw(drawData.data.point, drawData.data.style);
                        break;
                    default:
                        if(this.isRealTimeMode()){
                            t.draw(null, null, userId, 3);
                        }
                        // else{
                        // t.draw(drawData.data.point, null, user.userId, 0);
                        // }
                        t.draw(drawData.data.point, drawData.data.style);
                        break;
                }
                break;
            case 'drawtext':
                if(!t) return;
                t.drawText(drawData.data.point, drawData.data.text, drawData.data.style);
                break;
            case 'zoom':
                c.zoom(drawData.data.zoom);
                c.move(drawData.data.moveX, drawData.data.moveY);
                break;
            case 'zoomFit':
                c.zoomFit();
                break;
            case 'zoomOri':
                c.zoomOri();
                break;
            case 'clear':
                c.clearCanvas(false);
                break;
        }

        // RoomUI.Doc.drawDocumentStream();
    },
    setDrawDataList: function(roomDocPageDrawList){
        if(!roomDocPageDrawList || roomDocPageDrawList.length === 0){
            return;
        }

        let THIS = this;
        let c = THIS.csCanvas;
        c.getOptions().redraw = false;

        console.debug('## roomDocPageDrawList :', roomDocPageDrawList.length);
        let now = performance.now();
        try{
            let user = {
                userId: ''+Math.random()
            }

            let pointList, style
                ,currentToolkit
                ,currentToolkitDraw
            ;
            for(let i=0,iLen=roomDocPageDrawList.length; i<iLen; i++){
                let draw = roomDocPageDrawList[i];

                if(draw.toolkit==='LaserPointer'){
                    continue;
                }

                if(draw.data && typeof(draw.data)==='string'){
                    try{
                        draw.data = JSON.parse(draw.data);
                    }catch(e){
                        console.warn('setDrawDataList - drawData parse error', e);
                    }
                }
                let drawData = draw.data;

                if(draw.drawType === 'drawstart'){
                    if(drawData.point instanceof Array){
                        pointList = [drawData.point[0], drawData.point[1]];
                    }else{
                        pointList = [drawData.point.x, drawData.point.y];
                    }
                    style = drawData.style;
                }else if(draw.drawType === 'drawing'){
                    if(!pointList){
                        pointList = drawData.point;
                    }else{
                        for(let j=0, points=drawData.point, jLen=points.length; j<jLen; j++){
                            pointList.push(points[j]);
                        }
                    }
                }else if(draw.drawType === 'drawend'){
                    if(!drawData){
                        console.warn('draw data is null 1 :', draw);
                        continue;
                    }

                    switch (draw.toolkit) {
                        case 'Line':
                        case 'TwoLines':
                        case 'Rectangle':
                        case 'Diamond':
                        case 'Pentagon':
                        case 'Star':
                        case 'Circle':
                        case 'Triangle': {
                            if (currentToolkit) {
                                currentToolkit.draw(null, null, user.userId, 102);
                                currentToolkit = null;
                                currentToolkitDraw = true;
                            }

                            let t = c.toolkits[draw.toolkit];
                            if (t) {
                                t.draw(drawData.point, drawData.style);
                            }
                            break;
                        }
                        default: {
                            let t = c.toolkits[draw.toolkit];
                            if (t) {
                                t.draw(drawData.point, drawData.style);
                            }
                            break;
                        }
                    }
                }else if(draw.drawType === 'drawtext'){
                    if(currentToolkit){
                        currentToolkit.draw(null, null, user.userId, 102);
                        currentToolkit = null;
                        currentToolkitDraw = true;
                    }

                    let t = c.toolkits[draw.toolkit];
                    if(t){
                        t.drawText(drawData.point, drawData.text, drawData.style);
                    }
                }
            }

            if(!currentToolkitDraw && currentToolkit){
                currentToolkit.draw(null, null, user.userId, 102);
            }
        }catch(e){
            console.error('### setDrawDataList', roomDocPageDrawList, e.stack);
        }finally{
            c.getOptions().redraw = true;
            c.redraw();
        }
        console.debug('## roomDocPageDrawList draw end : %sms', (performance.now()-now).toFixed(2));
    },
    redraw: function(){
        this.csCanvas.redraw();
    }
});

export { RoomDocCanvas };